// This file is auto-generated by the `scripts/wallets/generate.ts` script.
// Do not modify this file manually.
export const wallet = {
    id: "me.easy",
    name: "EASY",
    homepage: "https://easy.me",
    image_id: "62feb41a-be1f-4b1c-e089-27f97c0e8d00",
    app: {
        browser: null,
        ios: "https://apps.apple.com/us/app/easy-web3-social-wallet/id1641192503",
        android: "https://play.google.com/store/apps/details?id=co.theeasy.app",
        mac: null,
        windows: null,
        linux: null,
        chrome: null,
        firefox: null,
        safari: null,
        edge: null,
        opera: null,
    },
    rdns: null,
    mobile: {
        native: "co.theeasy.app://",
        universal: "https://link.easy.me",
    },
    desktop: {
        native: null,
        universal: null,
    },
};
//# sourceMappingURL=index.js.map